import { render, staticRenderFns } from "./BrandPanel.vue?vue&type=template&id=fdd1f398&scoped=true"
import script from "./BrandPanel.vue?vue&type=script&lang=js"
export * from "./BrandPanel.vue?vue&type=script&lang=js"
import style0 from "./BrandPanel.vue?vue&type=style&index=0&id=fdd1f398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd1f398",
  null
  
)

export default component.exports